import { useState } from 'react';

import { LowEnrollmentTab } from '~features/new-dashboard/ui/low-enrollment-tab';
import { NearCapacityTab } from '~features/new-dashboard/ui/near-capacity-tab';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '~shared/shadcn/ui/tabs';

interface ClassPerformanceTabsProps {
  sessionId: string;
}

export const ClassPerformanceTabs = ({
  sessionId,
}: ClassPerformanceTabsProps) => {
  const [activeTab, setActiveTab] = useState('low-enrollment');

  return (
    <Card>
      <CardHeader className='pb-4'>
        <div className='flex items-center justify-between'>
          <CardTitle className='text-lg font-semibold text-[#000814]'>
            Class Performance
          </CardTitle>
          {/* <div className='flex items-center gap-3 text-xs text-slate-600'>
            <div className='flex items-center gap-1.5'>
              <div className='size-2 rounded-full bg-red-500' />
              <span>Low</span>
            </div>
            <div className='flex items-center gap-1.5'>
              <div className='size-2 rounded-full bg-yellow-500' />
              <span>Capacity</span>
            </div>
          </div> */}
        </div>
      </CardHeader>
      <CardContent>
        <Tabs value={activeTab} onValueChange={setActiveTab} className='w-full'>
          <TabsList className='mb-6 grid w-full grid-cols-2'>
            <TabsTrigger value='low-enrollment'>Low Enrollment</TabsTrigger>
            <TabsTrigger value='near-capacity'>Near Capacity</TabsTrigger>
          </TabsList>

          <TabsContent value='low-enrollment' className='space-y-5'>
            {activeTab === 'low-enrollment' && (
              <LowEnrollmentTab sessionId={sessionId} />
            )}
          </TabsContent>

          <TabsContent value='near-capacity' className='space-y-5'>
            {activeTab === 'near-capacity' && (
              <NearCapacityTab sessionId={sessionId} />
            )}
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};
